import type { Resolvers } from '../../generated';
import { state } from './state';

export const resolvers: Resolvers = {
  Mutation: {
    setAnnotationState: (_, vars) => {
      const { annotationId, annotationState, isSelected } = vars;
      const selectedAnnotation = state.selected.get();

      if (!annotationId) {
        state.selected.set({ id: null });
        return null;
      }

      if (state.drafts.has(annotationId)) {
        const draftState = state.drafts.get(annotationId);
        const newAnnotationState = {
          ...draftState,
          ...annotationState,
          id: annotationId,
        };

        state.drafts.set(annotationId, newAnnotationState);

        if (isSelected) {
          state.selected.set({ id: annotationId });
        } else if (
          isSelected === false &&
          selectedAnnotation?.id === annotationId
        ) {
          state.selected.set({ id: null });
        }

        return {
          ...newAnnotationState,
        };
      }

      return null;
    },
  },
};
